var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// TODO:
// vertical - padding variable?
import * as _ from 'lodash';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { AutoControlledComponent, childrenExist, customPropTypes, commonPropTypes, } from '../../lib';
import RadioGroupItem from './RadioGroupItem';
import { radioGroupBehavior } from '../../lib/accessibility';
/**
 * A radio group allows a user to select a value from a small set of options.
 * @accessibility
 * Implements ARIA Radio Group design pattern.
 */
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actionHandlers = {
            nextItem: function (event) { return _this.setCheckedItem(event, 1); },
            prevItem: function (event) { return _this.setCheckedItem(event, -1); },
        };
        _this.getItemProps = function (item) {
            return item.props || item;
        };
        _this.setCheckedItem = function (event, direction) {
            var nextItem = _this.findNextEnabledCheckedItem(direction);
            if (nextItem) {
                _this.setCheckedValue({
                    checkedValue: nextItem.value,
                    shouldFocus: true,
                    event: event,
                    props: nextItem,
                });
            }
            event.preventDefault();
        };
        _this.findNextEnabledCheckedItem = function (direction) {
            if (!_this.props.items || !_this.props.items.length) {
                return undefined;
            }
            var currentIndex = _.findIndex(_this.props.items, function (item) { return _this.getItemProps(item).value === _this.state.checkedValue; });
            for (var newIndex = currentIndex + direction; newIndex !== currentIndex; newIndex += direction) {
                if (newIndex < 0) {
                    newIndex = _this.props.items.length - 1;
                }
                else if (newIndex >= _this.props.items.length) {
                    newIndex = 0;
                }
                if (newIndex === currentIndex) {
                    return undefined;
                }
                var itemProps = _this.getItemProps(_this.props.items[newIndex]);
                if (!itemProps.disabled) {
                    return itemProps;
                }
            }
            return undefined;
        };
        _this.handleItemOverrides = function (predefinedProps) { return ({
            checked: typeof _this.state.checkedValue !== 'undefined' &&
                _this.state.checkedValue === predefinedProps.value,
            onClick: function (event, itemProps) {
                var value = itemProps.value, disabled = itemProps.disabled;
                if (!disabled && value !== _this.state.checkedValue) {
                    _this.setCheckedValue({ checkedValue: value, shouldFocus: false, event: event, props: itemProps });
                }
                _.invoke(predefinedProps, 'onClick', event, itemProps);
            },
            shouldFocus: _this.state.shouldFocus,
        }); };
        _this.renderItems = function (vertical) {
            var items = _this.props.items;
            return _.map(items, function (item) {
                return RadioGroupItem.create(item, {
                    defaultProps: { vertical: vertical },
                    overrideProps: _this.handleItemOverrides,
                });
            });
        };
        return _this;
    }
    RadioGroup.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, accessibility = _a.accessibility, rest = _a.rest;
        var _b = this.props, children = _b.children, vertical = _b.vertical;
        return (React.createElement(ElementType, __assign({}, accessibility.attributes.root, accessibility.keyHandlers.root, rest, { className: classes.root }), childrenExist(children) ? children : this.renderItems(vertical)));
    };
    RadioGroup.prototype.setCheckedValue = function (_a) {
        var checkedValue = _a.checkedValue, shouldFocus = _a.shouldFocus, event = _a.event, props = _a.props;
        this.trySetState({ checkedValue: checkedValue });
        this.setState({ shouldFocus: shouldFocus });
        _.invoke(this.props, 'checkedValueChanged', event, props);
    };
    RadioGroup.displayName = 'RadioGroup';
    RadioGroup.className = 'ui-radiogroup';
    RadioGroup.propTypes = __assign({}, commonPropTypes.createCommon({
        content: false,
    }), { accessibility: PropTypes.oneOfType([PropTypes.object, PropTypes.func]), checkedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), defaultCheckedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), items: customPropTypes.collectionShorthand, checkedValueChanged: PropTypes.func, vertical: PropTypes.bool });
    RadioGroup.defaultProps = {
        as: 'div',
        accessibility: radioGroupBehavior,
    };
    RadioGroup.autoControlledProps = ['checkedValue'];
    RadioGroup.Item = RadioGroupItem;
    return RadioGroup;
}(AutoControlledComponent));
export default RadioGroup;
